import {takeEvery} from 'redux-saga/effects'
import {
  SP_COMM_GET_FAQS,
  SP_COMM_GET_INQUIRY_TYPES,
  SP_COMM_SEND_FEEDBACK,
} from 'setup/redux/Actions/SpComm/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

/** Routes the student/parent help-screen requests through the shared fetch worker. */
function* spCommSagas() {
  yield takeEvery(SP_COMM_GET_FAQS, fetchData)
  yield takeEvery(SP_COMM_GET_INQUIRY_TYPES, fetchData)
  yield takeEvery(SP_COMM_SEND_FEEDBACK, fetchData)
}

export default spCommSagas
